import { API_BASE_URL } from "../../config";

async function handleRegisterNewUser(formData: any) {
    const res = await fetch(`${API_BASE_URL}/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
    });

    if (!res.ok) {
        throw new Error("Error al registrar el usuario");
    }

    const data = await res.json();

    return data;

}

export { handleRegisterNewUser };